<template>
  <div class="animated fadeIn"> 
    <b-row>
      <b-col sm="12">
        <b-card>
          <div slot="header">
            <strong><i class="cui-graph icons font-2xl mt-4"></i> Shipment Latest Status</strong>
            <div class="card-header-actions">                      
            </div>
          </div>  
           
           <!--  <form data-vv-scope="">
              <b-row>
                <b-col md="6" >  
                  <b-form-group label="Shipment Id" :label-cols="3"> 
                   <b-form-input class="input" type="text" name="shipmentid" v-model="" v-validate="" :class="" placeholder="Enter Shipment Id ">
                   </b-form-input>
                    <span v-show="" class="help text-danger"></span>
                   </b-form-group>          
                </b-col> 
                <b-col md="6" >
                  <b-button type="submit" size="md" class="mr-4" variant="primary"> Search</b-button>            
                </b-col>
              </b-row>  
            </form> --> 
           
    <!--  <b-container fluid>
              <b-row class="my-1">
              <b-col sm="6">
                <b-form-input  :type="type" 
                placeholder="Enter Shipping Id" v-bind:delimiter="[',']"
                style="border:1px solid #333"></b-form-input>
              </b-col>
              <b-col sm="6" >
                  <b-button type="submit" size="md" class="mr-4" variant="primary"> Search</b-button>            
                </b-col>
            </b-row>
            </b-container> -->    
           <div class="box">
            <form @submit.prevent="validateForm('form-1')" data-vv-scope="form-1">
              <b-row>
              <b-col md="6">
                <b-col sm="12" >
               <b-form-group label="Shipping Id"  :label-cols="4" >
                 
                <vue-tags-input
                v-model="customer.shippingid" 
                :tags="tags"
                 @tags-changed="newTags => tags = newTags  "
                  :avoidAddingDuplicates="avoidAddingDuplicates"
                 :placeholder="placeholder"
                  ref="taginput"
                 v-bind:separators="[',', ';']"
                   />
                   <span class="badge badge-success1">&nbsp;</span>&nbsp;
                   <label :label-cols="4" >Unique Shipping Id</label><br>
                   <span class="badge badge-success2">&nbsp;</span>&nbsp;&nbsp;<label :label-cols="4" >Repeat/Duplicate Shipping Id </label>
                 
                    <span v-show="errors.has('form-1.shipmentid')" class="help text-danger">{{ errors.first('form-1.shipmentid') }}</span>
                  </b-form-group>
                  </b-col> 
                </b-col>
                <b-col md="4" >
                  <b-button type="submit" size="md" class="mr-4" variant="primary"> Search</b-button>   
                  <b-button  @click="clear" size="md" variant="danger">Clear</b-button>        
                </b-col>
              </b-row>  
            </form>
          </div>   
       <!-- <form>
        <b-row>
           <b-col md="6">
             <b-form-group label="Shipping Id"  :label-cols="2" >
               <vue-tags-input
               
                 :placeholder="placeholder"
                 
                   />
             </b-form-group>
           </b-col>
            <b-col md="4" >
                  <b-button type="submit" size="md" class="mr-4" variant="primary"
                  style="margin-top: 100px;"> Search</b-button>            
                </b-col>
        </b-row>
       </form> -->
            <b-row>
              <b-col sm="12" class="text-right " >
                <b-col sm="12" class="text-right " >
                <b-button type="submit" v-if="this.totalRows >0" variant="primary" size="md" @click="downloadCSV">Download </b-button>
              </b-col>
              </b-col>

          </b-row>
          <b-col sm="12" class="text-right">
               <!--  <b-button v-if="this.totalRows >0"  variant="primary" size="md" @click="downloadCSV">Download </b-button>  -->
               <p > <b>Total Records :<span style="color:red;">{{totalRows}}</span></b> </p>
              </b-col> 

             <b-col sm="12">  
           <b-table show-empty stacked="md" style="table-layout: fixed"  :busy="isBusy" :current-page="currentPage"  :per-page="perPage"  :items="items" :fields="fields"   :bordered="bordered" :outlined="outlined" >

              <div slot="table-busy" class="text-center text-danger my-2">
                  <b-spinner class="align-middle"></b-spinner>
                  <strong>Loading...</strong>
                </div>
               
                

           </b-table>
         </b-col>
            <!--  <div class="row sm-10"> 
              <table class="table table-striped"  >
                 <thead>
                  <tr>
                    <th scope="col" style="border: 1px solid #c8ced3;">ShippingId</th>
                    <th scope="col" style="border: 1px solid #c8ced3;">OrderID</th>
                    <th scope="col" style="border: 1px solid #c8ced3;">AgentName</th>
                    <th scope="col" style="border: 1px solid #c8ced3;">Shipment Status</th>
                    <th scope="col" style="border: 1px solid #c8ced3;">Service Type</th>
                 
                    
                  </tr>
                </thead>
                 <tbody>
                  <td style="border: 1px solid #c8ced3;">FCUAE121238</td>
                  <td style="border: 1px solid #c8ced3;"></td>
                  <td style="border: 1px solid #c8ced3;">
                    ALIHASSANIAN ALI
                  </td>
                   <td style="border: 1px solid #c8ced3;">BookingDone</td>
                   <td style="border: 1px solid #c8ced3;">Delivery</td>
                  
                 </tbody>
              </table>
             </div> -->

              <!-- <div>
                <b-table striped hover :items="items"></b-table>
              </div> -->

              <b-col md="12" class="my-1 " v-if="this.totalRows > 20">
            <b-pagination
                v-model="currentPage"
                :total-rows="totalRows"
                :per-page="perPage"
                class="my-0"
              ></b-pagination>
          </b-col> 






                 
        </b-card>
      </b-col>
    </b-row>      
  </div>
</template>

<script>
import CONSTANTS from '@/utils/constants'
import Utils from '@/utils'
import VueTagsInput from '@johmun/vue-tags-input';
export default {
  components: {
    VueTagsInput,
  },
  data: function () {
    return {
      // delimiter: ',',
    // persist: false,
    //   value:input,
    //   text:input,
      type:'text',
      bordered: true,
       outlined:true,
      fields: [ 
      {key: 'shippingid',label:'ShippingID'}, 
       {key: 'shipmentstatus',label:'Shipment Status'},
       {key: 'deliverystatus',label:'Delivery Status'},  
       {key: 'lastmodifieddate',label:'LastModifiedDate'}, 
      ],
       items: [],
        customer: {},
         tags:[],
         placeholder:"Add shippingid",
       isBusy: false, 
      //  barcodeValue: '',
      // value:[],
      // // items:[],
      // // masterawbdata:[],
      // details:[],
      // shippinglist1:[],
      // shippinglist:[],
      // master:'',
      // checkedData: false,
      // bordered: true,
        totalRows: 0,
      //   receipturl:'',
      //   invoiceurl:'',
      //   lableurl:'',
        currentPage: 1,
        perPage: 20,
        pageOptions: [5, 10, 15],
        sortBy: null,
        sortDesc: true,
        sortDirection: 'desc',
        filter: null,
        isGetitemdetails:0,
        avoidAddingDuplicates:false,
     // pickup_pincode:[100002,100003,100004,100005,100002,100003,100004,100005,100002,100003,100004,100005,100002,100003,100004,100005,100002,100003,100004,100005],
      // items: [
      //     { Master_AWB:'BHR_ROAD_2021-04-02_1' , Submitted_Date: '2021-04-01', Receipt_No: '3456', Action:''},
      //     // { age: 21, first_name: 'Larsen', last_name: 'Shaw' },
      //     // { age: 89, first_name: 'Geneva', last_name: 'Wilson' },
      //     // { age: 38, first_name: 'Jami', last_name: 'Carney' }
      //   ],
        // fields:[
        //     {  key: "master_awb",label: 'Master AWB' },
        //     {  key: "dispatch_date",label: 'DispatchDate'},
        //     {  key: "receiptpdf",label: 'Receipt'},
        //     {key: 'invoicepdf', label: 'Invoice'},
        //      {key: 'lablepdf', label: 'Label'},
        //    {  key: "actions",label: 'Action' }
        // ]
    }
  },
   
  created: function () {
    // alert('created');
  },
  methods: {
      validateForm(scope) {
        if(this.tags.length>0){
         // var searchvaluesarr = []
      this.$validator.validateAll(scope).then((result) => {
        if (result) {
          var shipmentid=[];
       for(var i = 0; i < this.tags.length; i++) {
          shipmentid.push(this.tags[i].text);  
       }
          //  var shipmentid = this.customer.shipmentid
          // var searchvalues = shipmentid.split(',')
          // for (var i = 0; i < searchvalues.length; i++) {
          //   searchvaluesarr.push(`${searchvalues[i]}`)
          // }
          const customerGetAllobj = {
            shippingid: shipmentid
          }
           this.isBusy = true;
               this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/getLastStatusForShipment`, customerGetAllobj).then((result) => {
                // alert('innn');
                // console.log("lllll",result);
              // if (result.body.returnvalue.length > 0) 
               if (result.body.returnmsg==='Successful'){
                // alert('innn');
                this.items = result.body.returnvalue;
                // console.log("items", this.items);
                this.totalRows = result.body.returnvalue.length;
                // console.log("this.items",this.items);
                this.isGetitemdetails = 1
                this.isBusy =false
                
              } else {
                //alert('Result not found')
                this.items = []
                this.isGetitemdetails = 1
                this.isBusy = false

                
              }
            })
            .catch((ex) => {
              console.log('error', ex)
            })
        }
      });
    }else{
      // alert("Please Insert ShippingID");
       this.$fire({
                  text:"Please Insert ShippingID",
                  type: "warning",
                  timer: 30000
                });
    }
    },
    downloadCSV: function() {
   // document.getElementById("overlay").style.display = "block";
     var userdata = localStorage.getItem('userData')
      var userInfo = JSON.parse(userdata) 
 // alert(" i m i  Download");
 // alert(pagee);
          var shipmentid=[];
       for(var i = 0; i < this.tags.length; i++) {
          shipmentid.push(this.tags[i].text);  
       }
      
          var csvObj = {
          
          sysusermasterid:`${userInfo.sysusermasterid}`, 
          // hub_id:`${userInfo.pickuplocationmasterid}`, 
          // master_awb:this.master,
            shippingid: shipmentid,
           
          };
         
         
      

      // console.log(csvObj);
     
      
//         var queryString ="?"+ Object.keys(csvObj).map(key => key + '=' + csvObj[key]).join('&');
// console.log(queryString);
     
      //var r = Math.random().toString(36).substring(3);
this.$http.post(`${CONSTANTS.MISREPORT_API_URL}/getlaststatusforshipmentcsv`,csvObj)
        .then(result => {
         // console.log(result);
          // document.getElementById("overlay").style.display = "none";
          // if(result.body=="success")
          if(result.body.returnmsg=="Successful")
         {
         // alert("Please Check Your Mail For Downlod Link")
         this.$fire({
                  text:"Please Check Your Mail For Downlod Link",
                  type: "success",
                  timer: 30000
                });
       }
       else
       {
        // alert("Can not Download");
         this.$fire({
                  text:"Can not Download",
                  type: "error",
                  timer: 30000
                });
       }
        //window.location.href =result.url;
        });
    },

   

    clear: function() {
      // alert('in cl')
       this.tags=[];
      this.customer = {}
      this.errors.clear('form-1')
      // var searchlisting = document.getElementById('searchlisting')
      // searchlisting.style.display = 'none'
      // var searchlisting2 = document.getElementById('searchlisting2')
      // searchlisting2.style.display = 'none'
    }





  



     
   
  },

 
}
</script>
<style>
.ti-input[data-v-61d92e31] {
    border: 1px solid #ccc;
    display: flex;
    padding: 4px;
    flex-wrap: wrap;
    }
    .ti-new-tag-input-wrapper input[data-v-61d92e31] {
    flex: 1 0 auto;
    min-width: 100px;
    border: none;
    padding: 0px;
    margin: 0px;
  }
  .ti-input[data-v-61d92e31] {
    border: 1px solid #ccc;
    display: flex;
    padding: 4px;
    flex-wrap: wrap;
    width: 200px;
  }
  .ti-new-tag-input-wrapper[data-v-61d92e31] {
    display: flex;
    flex: 1 0 auto;
    padding: px 70px;
    padding: 10px 10px;
    margin: 2px;
    font-size: .85em;
}
</style>